// ** React Imports
import React from 'react'

// ** MUI Imports
import { IconButton, Tooltip, Typography } from '@mui/material'
import { Grid } from '@mui/material'
import { Info } from 'react-feather'

interface FormTileProps {
  id?: string
  children: React.ReactNode
  title?: string | undefined
  subtitle?: string | undefined
  tooltip?: string | undefined
  noBorder?: boolean
  endComponent?: React.ReactNode
}

const FormTile: React.FC<React.HTMLAttributes<HTMLDivElement> & FormTileProps> = ({
  className,
  children,
  title,
  subtitle,
  tooltip,
  noBorder,
  endComponent,
  id
}) => {
  return (
    <div
      className={`flex flex-col gap-3 bg-white ${
        !Boolean(noBorder) ? 'p-4 border rounded border-gray-light' : ''
      } ${className}`}
      id={id}
    >
      <Grid
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column'
        }}
      >
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row'
          }}
          justifyContent={'space-between'}
        >
          <div className='flex flex-col'>
            <Typography
              variant='subtitle1'
              sx={{ fontWeight: 500, color: 'text.header', display: 'flex', alignItems: 'center' }}
            >
              <span
                className={`${
                  tooltip ? 'underline decoration-2 decoration-dashed underline-offset-4 decoration-coal-lighter' : ''
                } `}
              >
                {title}
              </span>
              {Boolean(tooltip) ? (
                <Tooltip title={tooltip ?? ''} sx={{ transform: 'scale(0.9)', color: 'text.header', strokeWidth: 2.5 }}>
                  <IconButton size='small' aria-label='support'>
                    <Info className='scale-75 stroke-2 text-coal-light' />
                  </IconButton>
                </Tooltip>
              ) : (
                <></>
              )}
            </Typography>
            <Typography variant='caption' sx={{ fontWeight: 400, color: '#949494' }}>
              {subtitle}
            </Typography>
          </div>
          {Boolean(endComponent) && endComponent}
        </Grid>
      </Grid>
      {children}
    </div>
  )
}

export default FormTile
